module.exports = __webpack_public_path__ + "static/img/B智能显控终端.fd261b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/model/type-1/B智能显控终端.png
// module id = UFpN
// module chunks = 0